import { applyThresholdDefaults } from './apply-threshold-defaults.js';
import { DEFAULT_FORMATTER } from '../../shared/constants.js';
import { defaultConfig } from '../types/default.js';
import {
  MeterBarChartSlots,
  MeterBarChartConsumerConfig,
  type MeterBarChartThresholdConsumerConfig,
} from '../types/meter-bar-chart-config.js';
import {
  MeterBarChartInternalConfig,
  type ThresholdMetadata,
} from '../types/meter-bar-chart-internal.js';
import { MeterBarChartProps } from '../types/meter-bar-chart.js';

export const buildMeterBarChartConfig = (
  props: MeterBarChartProps,
  consumerConfig: MeterBarChartConsumerConfig,
  slots: MeterBarChartSlots,
): MeterBarChartInternalConfig => {
  const thresholds = combineThresholds(
    consumerConfig.thresholds,
    slots.thresholds,
  );
  const size = props.size ?? consumerConfig.size ?? defaultConfig.size;
  const min = props.min ?? consumerConfig.min ?? defaultConfig.min;
  const max = props.max ?? consumerConfig.max ?? defaultConfig.max;
  const tooltip =
    slots.tooltip ?? consumerConfig.tooltip ?? defaultConfig.tooltip;

  const formatter =
    props.formatter ?? consumerConfig.formatter ?? DEFAULT_FORMATTER;

  return {
    thresholds,
    size,
    min,
    max,
    tooltip,
    iconSlot: slots.icon,
    labelSlot: slots.label,
    valueSlot: slots.value,
    minSlot: slots.min,
    maxSlot: slots.max,
    formatter,
  };
};

const combineThresholds = (
  thresholdConfig: MeterBarChartThresholdConsumerConfig | undefined,
  thresholdSlots: ThresholdMetadata | undefined,
): ThresholdMetadata => {
  const slotsData = thresholdSlots?.data ? thresholdSlots.data : [];
  const consumerData = thresholdConfig?.data?.map(applyThresholdDefaults) ?? [];

  return {
    data: slotsData.concat(consumerData),
    legend:
      thresholdSlots?.legend ??
      thresholdConfig?.legend ??
      defaultConfig.thresholds.legend,
  };
};
